import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BuildGaugeComponent from './../Components/BuildGaugeComponent.jsx';
import {
  getBuildPageLatestDispatcherByType,
  getScenariosByDispatcherId,
  getMaxScenarioCountByDispatcherType,
  getJobById
} from './../reducers';
import { fetchScenariosByDispatcherIds } from './../actions';
import { DispatcherTypes, scenarios as constants, colours } from './../helpers';

export class DispatcherBuildGaugeContainer extends Component {
  static propTypes = {
    fetchScenariosByDispatcherIds: PropTypes.func.isRequired,
    dispatcher: PropTypes.shape({ id: PropTypes.number.isRequired })
  };

  componentDidUpdate() {
    if (!this.props.dispatcher) {
      return;
    }

    this.props.fetchScenariosByDispatcherIds([this.props.dispatcher.id]);
  }

  render() {
    return (
      <BuildGaugeComponent
        {...this.props}
      />
    );
  }
}

export const mapStateToProps = (state, ownProps) => {
  const dispatcher = getBuildPageLatestDispatcherByType(state, ownProps.type);
  const scenarios = dispatcher && getScenariosByDispatcherId(state, dispatcher.id);
  const job = dispatcher && getJobById(state, dispatcher.job_id);

  const maxScenarios = ownProps.type === DispatcherTypes.Artifact ?
    getMaxScenarioCountByDispatcherType(state, ownProps.type) :
    scenarios ? scenarios.length : 0;
  const completed = scenarios ?
    scenarios.filter(s => constants.isScenarioComplete(s.status)).length :
    0;

  const link = job ?
    `/${ownProps.endPoint}?nm=${job.name}&nb=${job.number}` :
    `/${ownProps.endPoint}`;

  const props = {
    dispatcher,
    completed,
    max: maxScenarios ? maxScenarios : 0,
    badge: constants.getPanelStyle(scenarios),
    link,
    pieData: [
      ...constants.getStateCounts(scenarios),
      maxScenarios + completed > 0 ? maxScenarios - completed : 1
    ],
    pieSlices: [
      ...constants.getPieSlices(constants.SCENARIO_IMPORTANCE, colours.colours),
      {
        label: 'Remaining',
        colour: colours.colours.grey
      }
    ]
  };
  return props;
};

export default connect(
  mapStateToProps,
  { fetchScenariosByDispatcherIds }
)(DispatcherBuildGaugeContainer);


// WEBPACK FOOTER //
// src/Containers/DispatcherBuildGaugeContainer.jsx